module.exports = __webpack_public_path__ + "static/media/f-mail.cc72ae00.svg";